var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0992 6.10012C9.58825 6.09837 9.08196 6.19738 8.6093 6.3915C8.13664 6.58563 7.7069 6.87104 7.34467 7.23142C6.98243 7.5918 6.69481 8.02007 6.49826 8.49172C6.30171 8.96337 6.20009 9.46915 6.19922 9.98012V13.9001C6.19922 14.0593 6.26243 14.2119 6.37495 14.3244C6.48748 14.4369 6.64009 14.5001 6.79922 14.5001H8.19922C8.35835 14.5001 8.51096 14.4369 8.62348 14.3244C8.736 14.2119 8.79922 14.0593 8.79922 13.9001V9.98012C8.79909 9.79839 8.83726 9.61867 8.91124 9.45268C8.98522 9.28668 9.09336 9.13815 9.22859 9.01675C9.36383 8.89535 9.52313 8.80381 9.69612 8.74811C9.8691 8.6924 10.0519 8.67378 10.2326 8.69345C10.5566 8.73426 10.8543 8.89256 11.0694 9.13833C11.2844 9.38409 11.4018 9.70023 11.3992 10.0268V13.9001C11.3992 14.0593 11.4624 14.2119 11.575 14.3244C11.6875 14.4369 11.8401 14.5001 11.9992 14.5001H13.3992C13.5583 14.5001 13.711 14.4369 13.8235 14.3244C13.936 14.2119 13.9992 14.0593 13.9992 13.9001V9.98012C13.9983 9.46915 13.8967 8.96337 13.7002 8.49172C13.5036 8.02007 13.216 7.5918 12.8538 7.23142C12.4915 6.87104 12.0618 6.58563 11.5891 6.3915C11.1165 6.19738 10.6102 6.09837 10.0992 6.10012Z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 6.69995H2.6C2.26863 6.69995 2 6.96858 2 7.29995V13.9C2 14.2313 2.26863 14.5 2.6 14.5H4.4C4.73137 14.5 5 14.2313 5 13.9V7.29995C5 6.96858 4.73137 6.69995 4.4 6.69995Z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.5C4.32843 5.5 5 4.82843 5 4C5 3.17157 4.32843 2.5 3.5 2.5C2.67157 2.5 2 3.17157 2 4C2 4.82843 2.67157 5.5 3.5 5.5Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f044b04dfa0462e6321313fa819f9109.svg";
export { ForwardRef as ReactComponent };